import _extends from '@babel/runtime/helpers/extends';
import React from 'react';

var Pillar = function Pillar(props) {
  // eslint-disable-next-line react/prop-types
  var id = props.id;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 6 30"
  }, props), /*#__PURE__*/React.createElement("title", null, "Pillar"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    id: "".concat(id, "-Symbols"),
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "".concat(id, "-Pillar"),
    fill: "#00BF66",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "".concat(id, "-Path"),
    points: "6.43393393 0 0 5.35660661 0 30 6.43393393 24.6427678"
  }))));
};

var Pillar$1 = Pillar;

export { Pillar$1 as default };
